<script>
  import { connectWallet, currentAddress } from '../../../scripts/eth';;

  
  let cursor='cursor: pointer';
 
  function cursorNo() {
    cursor = 'cursor: not-allowed';
  }

  function cursorYes() {
    cursor = 'cursor: pointer';
  }

  let address = '';
  currentAddress.subscribe(value => {
		if (value == null || value == '' || value == '0x0')  {
			address = ''
		} else {
			address =  '   '+ value.substring(0,6)+'...'+ value.substring(38) + '   ';
		}
	});
</script>

<div class="connect-wallet-wrapper">
  <button class="connect-wallet-button" style='{cursor}' on:click={connectWallet}>
    {#if (address != '' && address != '   0x0...   ')}
      <img src='images/account.svg' alt="Account Logo" class="account-logo" on:load={cursorNo}/>

      <h1>{address}</h1>
    {:else}
      <img src='images/metamask.svg' alt="MetaMask Logo" class="metamask-logo" on:load={cursorYes}/>

      <h1>Connect Wallet</h1>
    {/if}
  </button>
</div>

<style>
  .connect-wallet-wrapper {
    display: flex;
    justify-content: flex-end;
  }

  .connect-wallet-wrapper button {
    border: 1px solid transparent;
    background-image: linear-gradient(92.29deg, var(--primary-color) 0%, var(--gradient) 100%),
      linear-gradient(92.29deg, var(--primary-color) 0%, var(--gradient) 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-origin: border-box;
    background-clip: content-box, border-box;
    box-shadow: 2px 1000px 1px #fff inset;
    width: 200px; 
		height: 64px;
    padding: 16px 18px;

  }

  h1 {
    font-family: Montserrat;
		font-style: normal;
		font-weight: bold;
		font-size: 16px;
		line-height: 20px;
		/* identical to box height */

		display: flex;
		align-items: center;
		text-align: center;

		color: #333333;
  }

  .connect-wallet-wrapper button img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
</style>
